import { render, staticRenderFns } from "./PlayerDevice.vue?vue&type=template&id=04ced53e&scoped=true&"
import script from "./PlayerDevice.vue?vue&type=script&lang=js&"
export * from "./PlayerDevice.vue?vue&type=script&lang=js&"
import style0 from "./PlayerDevice.vue?vue&type=style&index=0&id=04ced53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ced53e",
  null
  
)

export default component.exports